;(function () {
  var logoutDelay = 60 * 2 // two minutes

  function keepSession() {
    window.metrics.opalTrack('Inactivity keep session')

    this.reset()
  }

  function destroySession() {
    window.metrics.opalTrack('Inactivity logout')
    this.clearListeners()

    jQuery.ajax('/login', {
      data: { reason: 'inactivity_timeout' },
      dataType: 'json',
      method: 'DELETE',
      error: function () {
        window.location.reload(true)
      },
      success: function (options) {
        window.location.assign(options.destination)
      },
    })
  }

  function dismissPrompt() {
    if (this.prevTitle) document.title = this.prevTitle

    var shroudArea = document.getElementById('shroud_region')
    ReactDOM.unmountComponentAtNode(shroudArea)
  }

  function onTimeout() {
    window.metrics.opalTrack(
      'Inactivity timeout (' + this.options.timeout_period + ' seconds)'
    )
    this.clearListeners()

    this.prevTitle = document.title
    document.title = 'Still working? | ' + this.prevTitle

    var shroudArea = document.getElementById('shroud_region')
    var component = React.createElement(
      window.Kuiper.Modal,
      {
        displayExitButton: false,
        visible: true,
      },
      React.createElement(window.Kuiper.CountDownAlert, {
        alertTitle: 'Still working?',
        cancelButtonText: 'Log out',
        confirmButtonText: 'Keep using Opal',
        secondsRemaining: this.options.grace_period,
        keepSession: keepSession.bind(this),
        destroySession: destroySession.bind(this),
        textBeforeTime: 'You will be logged out in',
        textAfterTime: "if we don't hear from you.",
      })
    )

    ReactDOM.render(component, shroudArea)
  }

  function InactivityTimer(timeout, options) {
    if (!timeout) return

    var mergedOptions = _.defaults({}, options, {
      name: 'InactivityTimer',
      onGracePeriodTimeout: destroySession,
      onSharedTimerReset: dismissPrompt,
      onTimeout: onTimeout,
      debug: true,
      grace_period: logoutDelay,
      timeout_period: timeout,
      onReset: dismissPrompt,
    })

    new window.opalModern.SharedTimeout(mergedOptions)
  }

  window.InactivityTimer = InactivityTimer
})()
